import 'simplebar/dist/simplebar.min.css';
import 'nprogress/nprogress.css';
import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import store from './store';
import { App } from './app';
import { injectStore } from './api/client';

injectStore(store);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <App />
            <Toaster
              position="bottom-right"
              toastOptions={{
                duration: 10000,
                style: {
                  borderRadius: '10px',
                  boxShadow: 'rgb(0 0 0 / 45%) 0px 5px 20px'
                }
              }}
            />
          </LocalizationProvider>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  </StrictMode>
);
